import { Component } from '@angular/core'

@Component({
  selector: 'hs-upload-transactions-file',
  templateUrl: './upload-transactions-file.component.html',
  styleUrls: ['./upload-transactions-file.component.scss'],
})
export class UploadTransactionsFileComponent {}
